import { presidentialProfiles } from './registry.js';

const STORAGE_KEY = 'vitrine-presidents-comparison';

export function readPresidentSelection(): string[] {
  if (typeof window === 'undefined') return [];
  try {
    const raw = JSON.parse(window.sessionStorage.getItem(STORAGE_KEY) ?? '[]') as unknown;
    if (!Array.isArray(raw)) return [];
    return [...new Set(raw.filter((slug): slug is string => typeof slug === 'string'
      && presidentialProfiles.some((profile) => profile.slug === slug && profile.comparable)))].slice(0, 4);
  } catch { return []; }
}

export function savePresidentSelection(selection: string[]) {
  if (typeof window === 'undefined') return;
  try { window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify(selection.slice(0, 4))); } catch { /* Session storage is optional. */ }
}

export function presidentComparisonUrl(selection: string[]) {
  const params = new URLSearchParams();
  if (selection.length) params.set('pessoas', selection.join(','));
  return `/presidentes/comparar${params.size ? `?${params.toString()}` : ''}`;
}
